import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import DRAG_HINT from 'public/assets/svg/pano_drag_360.svg'
import { WithAnimation } from 'aria-viewer/common'

const getOrbitAnim = function(props) {
    const ringWidth = props.width
    const animation = {
        '0': {
            width: ringWidth + 'px',
        },
        '100': {
            width: '0px',
        },
    }
    return window.CSSHelpers.Keyframes(animation)
}
const getOrbitAngle = function(props) {
    const index = props.index
    const angles = [45, 90, 135]
    return angles[index % angles.length]
}

const style = {
    indicatorContainer: {
        textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: ({ options }) => (options && options.hintPosition ? options.hintPosition.top : '40%'),
        left: 0,
        margin: '0 auto',
        marginTop: '60px',
        background: 'rgba(0,0,0,0)',
        color: 'rgba(255, 255, 255, 1)',
        zIndex: '2005',
        fontSize: '20px',
        cursor: 'pointer',
        opacity: 1,
        transform: 'translate3d(0px, 0px, 0px)',
    },
    icon360: {
        position: 'relative',
        background: `url(${DRAG_HINT})`,
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        width: '54px',
        height: '37px',
        margin: '-52px auto 0',
        zIndex: '1000',
    },
    centerBlackCircle: {
        position: 'relative',
        background: 'rgba(0,0,0,.4)',
        border: '2px solid #fff',
        borderRadius: '100%',
        backgroundRepeat: 'no-repeat',
        width: '80px',
        height: '80px',
        paddingBottom: '0px',
        margin: '-128px auto 0',
    },
    orbitRingPivot: {
        border: '2px solid rbga(0,0,0,0)',
        position: 'relative',
        borderRadius: '50%',
        width: '76px',
        height: '76px',
        top: '14px',
        margin: '-66px auto 0',
    },
    animationContainer: {
        pointerEvents: 'none',
    },
}

const RING_WIDTH = 78
const ringStyle = {
    '@keyframes orbit': {
        '0%': {
            width: RING_WIDTH + 'px',
        },
        '100%': {
            width: '0px',
        },
    },
    orbitRing: {
        border: '1px solid #FFFFFF',
        position: 'absolute',
        top: 'calc(50% - 62px)',
        left: '50%',
        borderRadius: '50%',
        width: RING_WIDTH + 'px',
        height: RING_WIDTH + 'px',
        zIndex: '1000',
        transformOrigin: 'center',
        animation: ({ ringId }) => 'orbit 1s ' + ringId * 0.4 + 's linear infinite alternate both',
        transform: ({ ringId }) =>
            'translate3d(-50%, -50%,0) ' + 'rotate3d(0, 0, 1, ' + getOrbitAngle({ index: ringId }) + 'deg)',
    },
}

const OrbitRing = injectSheet(ringStyle)(({ classes, ringId }) => <div className={classes.orbitRing} />)

const DraggingHint = ({ classes, hintText, showAnimation }) => (
    <div className={classes.indicatorContainer}>
        {hintText}
        {showAnimation && (
            <div>
                <div className={classes.orbitRingPivot}>
                    <OrbitRing ringId={0} />
                    <OrbitRing ringId={1} />
                    <OrbitRing ringId={2} />
                </div>
                <div className={classes.centerBlackCircle} />
                <div className={classes.icon360} />
            </div>
        )}
    </div>
)

DraggingHint.defaultProps = {
    showAnimation: false,
    hintText: 'Drag to look around',
}

export default compose(
    injectSheet(style),
    WithAnimation({
        className: ({ classes }) => classes.animationContainer,

        show: ({ isVisible }) => isVisible,

        start: {
            opacity: 0,
        },

        enter: {
            opacity: [1],
            timing: ({ delay }) => ({ duration: delay }),
        },

        update: {
            opacity: [1],
            timing: ({ delay }) => ({ duration: delay }),
        },

        leave: {
            opacity: [0],
            timing: ({ delay }) => ({ duration: delay }),
        },
    }),
    pure
)(DraggingHint)
